module.exports = __webpack_public_path__ + "static/media/menuChart.7ddd2582.svg";